import { createAction, props } from '@ngrx/store';
import { ServiceGridItemObject, WorkObject } from '@it2go/types';

export const
    setWork = createAction('[services] setWork', props<{ work: WorkObject }>()),
    setWorkRecordDate = createAction('[services] setWorkRecordDate', props<{ workRecordDate: Date }>());

export const
    setService = createAction('[services] setService', props<{ service: ServiceGridItemObject | null }>());
